import { MediaThumbnail } from '@components/MediaThumbnail/MediaThumbnail';
import React from 'react';
import css from '../LibraryContentMediaTable.module.scss';
import { ThumbnailCellProps } from './types';

export const ThumbnailCell = React.memo<ThumbnailCellProps>(
  ({ media, hasThumbnailError, onThumbnailError, onThumbnailClick }) => {
    const handleClick = (e: React.MouseEvent) => {
      onThumbnailClick(media, e);
    };

    // Keeps the grid from treating a press on the thumbnail as a press on the cell. Deliberately
    // does not `preventDefault`: on `mousedown` that cancels the native drag before it starts, and
    // the thumbnail is where a row is most naturally grabbed to drag it onto a folder. An image
    // dragged from here cannot be taken for an upload — `useDragDropUpload` ignores drags that
    // start in the document.
    const handleMouseDown = (e: React.MouseEvent) => {
      e.stopPropagation();
    };

    return (
      <div
        className={css.thumbnailContainer}
        onClick={handleClick}
        onMouseDown={handleMouseDown}
        style={{ cursor: 'pointer' }}
      >
        <MediaThumbnail
          media={media}
          onError={onThumbnailError}
          hasExternalError={hasThumbnailError}
          classNames={{
            audioIcon: css.audioIcon,
            videoIcon: css.videoIcon,
          }}
        />
      </div>
    );
  },
);

ThumbnailCell.displayName = 'ThumbnailCell';
